export default "__VITE_ASSET__Bm6irt6z__"